import { CardResolutionType } from "./CardResolutionType";
import { updateStatusReport } from "services";
import { Report } from "interfaces";
import { useConfirmDialogExit } from "hooks";
import { useSnackbar } from "providers/SnackbarProvider";

import {
  modalCardResolutionTypeHelpTextCorrect,
  modalCardResolutionTypeHelpTextPartiallyWrong,
  modalCardResolutionTypeSubTitleCorrect,
  modalCardResolutionTypeSubTitlePartiallyWrong,
  modalCardResolutionTypeTitleCorrect,
  modalCardResolutionTypeTitlePartiallyWrong,
  snackbarReportResolvedSubTitleCorrect,
  snackbarReportResolvedSubTitleWarning,
  snackbarReportResolvedTitle,
} from "_constants";
import { useContext, useState } from "react";
import { ModalResolveReportPartiallyWrong } from "components/modals/ModalResolveReportPartiallyWrong/ModalResolveReportPartiallyWrong";
import { DetailPanelContext } from "providers/DetailPanelProvider";
import { useAppDispatch } from "store/store";
import { setPageReports } from "store/slicer/GestioneReportSlice";
import { setCheckOpenedReportLoadStatus } from "store/slicer/CheckOpenedReportSlice";

export const CardResolutionTypeContainer = ({
  report,
  onClose,
}: {
  report: Report;
  onClose: Function;
}) => {
  const [showModal, setShowModal] = useState(false);
  const dispatch = useAppDispatch();
  const { showConfirmUpdateStatusReport } = useConfirmDialogExit();
  const { showSnackbar } = useSnackbar();
  const { hidePanel } = useContext(DetailPanelContext);

  const confirmUpdateStatusReport = (value: boolean) => {
    updateStatusReport({ id: report.id, delete: value })
      .then((_) => {
        showSnackbar({
          severity: "success",
          summary: snackbarReportResolvedTitle,
          detail: value
            ? snackbarReportResolvedSubTitleWarning
            : snackbarReportResolvedSubTitleCorrect,
          life: 5000,
        });
        dispatch(setPageReports(-1));
        setTimeout(() => {
          dispatch(setPageReports(1));
        }, 200);
        dispatch(setCheckOpenedReportLoadStatus(false));
        hidePanel();
        onClose();
      })
      .catch((_) => {});
  };

  const openUpdateStatusConfirmModal = (value: boolean) => {
    showConfirmUpdateStatusReport({
      callback: () => confirmUpdateStatusReport(value),
    });
  };

  const openModalResolvePartiallyWrongReport = () => {
    setShowModal(true);
  };

  const resolveReport = (type: number) => {
    switch (type) {
      case 0:
        openUpdateStatusConfirmModal(false);
        break;
      case 1:
        openUpdateStatusConfirmModal(true);
        break;
      case 2:
        openModalResolvePartiallyWrongReport();
        break;
      default:
        break;
    }
  };

  return (
    <>
      <div className="flex-container gap-8">
        <CardResolutionType
          title={modalCardResolutionTypeTitleCorrect}
          subtitle={modalCardResolutionTypeSubTitleCorrect}
          helpText={modalCardResolutionTypeHelpTextCorrect}
          callback={() => resolveReport(0)}
          type="correct"
        />
        <CardResolutionType
          title={modalCardResolutionTypeTitlePartiallyWrong}
          subtitle={modalCardResolutionTypeSubTitlePartiallyWrong}
          helpText={modalCardResolutionTypeHelpTextPartiallyWrong}
          callback={() => resolveReport(2)}
          type="partially_wrong"
        />
      </div>
      <ModalResolveReportPartiallyWrong
        showModal={showModal}
        report={report}
        onClose={() => {
          onClose();
          setShowModal(false);
        }}
      />
    </>
  );
};
